import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Tooltip from '..';

const InvalidFlightTooltip = ({ placement }) => {
  const { isViewingBrochure } = useSelector((state) => state.brochure);
  return (
    <Tooltip
      title={`This flight option is missing a return segment and will be removed upon saving the ${isViewingBrochure ? 'brochure' : 'compare'}. To retain it, please add a corresponding return flight to ${isViewingBrochure ? 'brochure' : 'compare'}.`}
      placement={placement}
      disableHoverListener={false}
      showCloseIcon={false}
      variant="light"
    >
      <span className="text-red-400">
        <span role="img" aria-label="Warning">
          ⚠️
        </span>{' '}
        Invalid flight option
      </span>
    </Tooltip>
  );
};
InvalidFlightTooltip.propTypes = {
  placement: PropTypes.string,
};
InvalidFlightTooltip.defaultProps = {
  placement: 'top',
};
export default InvalidFlightTooltip;
